<template>
  <div class="plan-card-container">
    <div class="pc-header flex-row just-between">
      <div style="width: 18px" />
      <span>
        {{ plan.name || "Plan Name" }}
      </span>
      <div
        tabindex="0"
        style="position: relative"
        @focusin="toggleShow(plan.planId)"
        @focusout="toggleShow(0)"
      >
        <button focus="" type="button" class="dots-btn">
          <v-icon color="white" medium> mdi-dots-vertical </v-icon>
        </button>
        <div
          :class="[
            'plan-actions-container',
            adminRole !== 'viewer' && show == plan.planId ? 'active' : '',
          ]"
          tabindex="0"
          @focusin="toggleShow(plan.planId)"
        >
          <button
            v-if="currentPath"
            type="button"
            class="plan-action-button"
            @click="
              plan.activeMembers === 0
                ? toggleLocalActionModal(plan, true, 'edit')
                : toggleLocalActionModal(plan, true, 'edit-plan-warn')
            "
          >
            Edit plan
          </button>
          <button
            v-if="plan.status === 'Active'"
            type="button"
            class="plan-action-button"
            @click="toggleLocalActionModal(plan, true, 'archive')"
          >
            Archive plan
          </button>
          <button
            v-else-if="plan.status === 'Archived'"
            type="button"
            class="plan-action-button"
            @click="toggleLocalActionModal(plan, true, 'unarchive')"
          >
            Unarchive plan
          </button>
          <button
            v-if="plan.status === 'Active' || plan.status === 'Archived'"
            type="button"
            class="plan-action-button"
            @click="toggleLocalActionModal(plan, true, 'delete')"
          >
            Delete plan
          </button>
        </div>
      </div>
    </div>
    <div class="pc-body-container">
      <div v-if="plan.status === 'Archived'" class="pc-body-banner">
        <span class="margin-right-4">Archived</span><i class="icon-luc-Archive" />
      </div>
      <div
        v-if="planPriceInitial !== 0 && planPriceInitial !== '0'"
        class="pc-price-container"
      >
        <span class="pc-price-dollar-sign">$</span>
        <span class="pc-price">
          {{ planPriceInitial }}
        </span>
        <span v-if="!plan.chargeFrequency" class="pc-price-label"> /month </span>
        <span v-else class="pc-price-label"> /{{ displayChargeFrequency }} </span>
        <div v-if="plan.planId === preferredPlan" class="pc-pref-badge-container">
          <span class="pc-pref-badge-text">Preferred</span>
          <img src="@shared/assets/img/general/star.svg" alt="Preferred" />
        </div>
      </div>
      <div v-else class="pc-price-container">
        <span class="pc-price"> Free </span>
        <div v-if="plan.planId === preferredPlan" class="pc-pref-badge-container">
          <span class="pc-pref-badge-text">Preferred</span>
          <img src="@shared/assets/img/general/star.svg" alt="preffered" />
        </div>
      </div>
      <div v-if="plan.comfortCreditInitial" class="pc-cc-container">
        {{ plan.comfortCreditInitial }}
        {{ loyaltyName }} /{{ displayCreditAccrualFrequency }}
      </div>
      <div class="pc-body-header">Smart Maintenance&reg;</div>
      <div v-if="plan.services.length === 0" class="pc-body-list-container">
        <div v-if="plan?.planType !== 'AppOnly'" class="pc-body-list-item">
          <img src="@shared/assets/img/setting/bullet.svg" class="bullet" alt="bullet" />
          <div class="pc-body-list-text">Smart sensors & installation</div>
        </div>
        <div v-else class="pc-body-list-item">
          <img src="@shared/assets/img/setting/bullet.svg" class="bullet" alt="bullet" />
          <div class="pc-body-list-text">
            Troubleshooting via technician chat or live video
          </div>
        </div>
        <div v-if="plan?.planType !== 'AppOnly'" class="pc-body-list-item">
          <img src="@shared/assets/img/setting/bullet.svg" class="bullet" alt="bullet" />
          <div class="pc-body-list-text">Monthly system health reports</div>
        </div>
        <div v-else class="pc-body-list-item">
          <img src="@shared/assets/img/setting/bullet.svg" class="bullet" alt="bullet" />
          <div class="pc-body-list-text">In-app priority scheduling</div>
        </div>
        <div class="pc-body-list-item">
          <img src="@shared/assets/img/setting/bullet.svg" class="bullet" alt="bullet" />
          <div class="pc-body-list-text">Discounted filter replacement</div>
        </div>
        <div v-if="plan?.planType !== 'AppOnly'" class="pc-body-list-item">
          <img src="@shared/assets/img/setting/bullet.svg" class="bullet" alt="bullet" />
          <div class="pc-body-list-text">Live chat with a technician</div>
        </div>
        <div v-else class="pc-body-list-item">
          <img src="@shared/assets/img/setting/bullet.svg" class="bullet" alt="bullet" />
          <div class="pc-body-list-text">Member exclusive promotions and vouchers</div>
        </div>
      </div>
      <div v-else class="pc-body-list-container">
        <div v-for="s in plan.services" :key="s.serviceId" class="pc-body-list-item">
          <img src="@shared/assets/img/setting/bullet.svg" class="bullet" alt="bullet" />
          <div class="pc-body-list-text">
            {{ s.service }}
          </div>
        </div>
      </div>
      <div
        v-if="
          finishedSection && !finishedSection.includes('planDetail') && type !== 'edit'
        "
      >
        <div class="pc-body-title">System Inspections</div>
        <div class="pc-body-bubble-container">- In-person | - Virtual | - Flex</div>
      </div>
      <div
        v-else-if="plan.inspectionPerson || plan.inspectionVirtual || plan.inspectionFlex"
        class="pc-content-container"
      >
        <div class="pc-body-title">System Inspections</div>
        <div class="pc-body-bubble-container">
          {{ plan.inspectionPerson ? `${plan.inspectionPerson} In-person` : null }}
          {{
            (plan.inspectionPerson && plan.inspectionVirtual) ||
            (plan.inspectionPerson && plan.inspectionFlex)
              ? "&nbsp;|&nbsp;"
              : null
          }}
          {{ plan.inspectionVirtual ? `${plan.inspectionVirtual} Virtual` : null }}
          {{ plan.inspectionVirtual && plan.inspectionFlex ? "&nbsp;|&nbsp;" : null }}
          {{ plan.inspectionFlex ? `${plan.inspectionFlex} Flex` : null }}
        </div>
      </div>
      <div
        v-if="
          (!finishedSection ||
            finishedSection.includes('signUpBonus') ||
            type === 'edit') &&
          (plan.bonusComfortCredit || plan.bonusFilterVoucher)
        "
      >
        <div class="pc-body-title">Sign Up Bonus:</div>
        <div
          v-if="plan.bonusComfortCredit"
          class="pc-body-bubble-container pc-body-bubble-container--bonus flex-row"
        >
          <span class="pc-bubble-icon pc-bubble-icon--cc" aria-hidden="true">
            <img src="@shared/assets/img/setting/cc-icon.svg" alt="" />
          </span>
          <span class="pc-bubble-bonus-text">
            <span class="pc-loyalty-name"
              >${{ plan.bonusComfortCredit }} {{ loyaltyName }}</span
            >
            <span
              v-if="
                (plan.bonusComfortCredit || plan.bonusFilterVoucher) &&
                signupBonusAccrualLabel
              "
              class="pc-bubble-bonus-accrual"
            >
              Awarded per {{ signupBonusAccrualLabel }}
            </span>
          </span>
        </div>
        <div
          v-if="plan.bonusFilterVoucher"
          class="pc-body-bubble-container pc-body-bubble-container--bonus flex-row margin-top-4"
        >
          <span class="pc-bubble-icon pc-bubble-icon--filter" aria-hidden="true">
            <img src="@shared/assets/img/setting/filter-icon.svg" alt="" />
          </span>
          <span class="pc-bubble-bonus-text">
            ${{ plan.bonusFilterVoucher }} Filter Voucher /
            {{ plan.bonusFilterVoucherFrequency }}
          </span>
        </div>
      </div>
    </div>
    <div class="pc-footer-container">
      <button
        v-if="!hideDetails"
        type="button"
        class="pc-plan-button"
        @click="toggleLocalActionModal(plan, true, 'details')"
      >
        See Plan Details
      </button>
    </div>
  </div>
</template>

<script>
import providerPlanMixin from "@shared/mixins/providerPlanMixin";

export default {
  name: "PlanCard",
  mixins: [providerPlanMixin],
  props: {
    plan: Object,
    type: String,
    finishedSection: Array,
    hideDetails: Boolean,
    currentPath: String,
    adminRole: String,
    toggleLocalActionModal: Function,
    partnerSettings: Object,
    isSmacAdmin: Boolean,
  },
  data() {
    return {
      show: 0,
    };
  },
  computed: {
    planPriceInitial() {
      if (this.plan.priceInitial) {
        if (this.plan.priceInitial % 1 === 0) {
          return this.plan.priceInitial;
        }
        return Number(this.plan.priceInitial).toFixed(2);
      }
      return 0;
    },
    displayChargeFrequency() {
      if (this.plan.chargeFrequency === "Yearly") {
        return "year";
      }
      if (this.plan.chargeFrequency === "Monthly") {
        return "month";
      }
      if (this.plan.chargeFrequency === "One time") {
        return "once";
      }
      return this.plan.chargeFrequency.toLowerCase();
    },
    displayCreditAccrualFrequency() {
      if (this.plan.creditAccrualFrequency === "Yearly") {
        return "year";
      }
      if (this.plan.creditAccrualFrequency === "Monthly") {
        return "month";
      }
      return this.plan.creditAccrualFrequency.toLowerCase();
    },
    loyaltyName() {
      return this.partnerSettings.LOYALTY_PROGRAM_NAME || "Comfort Credits";
    },
    signupBonusAccrualLabel() {
      const value = this.plan.signupBonusAccrual || this.plan.SignupBonusAccrual;
      if (!value) return null;
      if (value === "Subscriber") return "Member";
      if (value === "Hub") return "System";
      if (value === "Location") return "Location";
      return value;
    },
    preferredPlan() {
      const planId = this.partnerSettings?.PREFERRED_PLAN_ID || "";

      const plan = this.plans.filter((p) => p.planId === Number(planId));
      return plan.length > 0 ? plan[0].planId : null;
    },
  },
  methods: {
    toggleShow(id) {
      if (id === false) {
        this.show = 0;
      }
      this.show = id;
    },
  },
};
</script>

<style lang="scss">
.plan-card-container {
  width: 30%;
  min-width: 240px;
  min-height: 520px;
  margin-right: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
  border-radius: 14px;
  display: flex;
  flex-direction: column;

  @media (min-width: 1700px) {
    min-height: 550px;
  }

  .pc-header {
    background-color: #001b39;
    color: $WHITE;
    font-size: 1em;
    font-weight: 500;
    height: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;

    .dots-btn {
      padding-right: 10px;
    }
  }

  .plan-actions-container {
    position: absolute;
    background-color: #ebf1f7;
    border-radius: 8px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
    right: 0;
    z-index: 1;
    transform: scaleY(0);
    transform-origin: top;
    transition: transform 100ms ease;

    &.active {
      transform: scaleY(1);
    }

    .plan-action-button {
      padding: 6px 12px;
      text-align: left;
      font-size: 12px;
      font-weight: 500;
      width: 130px;
      color: black;
      &:not(:last-child) {
        border-bottom: 1px solid $N20;
      }
      &:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      &:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      &:hover {
        background-color: #4980ff;
        color: white;
      }
    }
  }

  .pc-body-container {
    flex: 1;
    padding: 24px 16px;
    background-color: $WHITE;
    position: relative;

    .pc-body-banner {
      position: absolute;
      top: 8px;
      right: 6px;
      height: 24px;
      background-color: #e5e5e5;
      font-size: 0.875em;
      color: #6c6c6c;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 6px;
      border-radius: 4px;
    }

    .pc-price-container {
      display: flex;
      line-height: 1;
      position: relative;
      .pc-price-dollar-sign {
        font-size: 0.75em;
        font-weight: 700;
        margin-top: 3px;
      }

      .pc-price {
        color: $NAVY100;
        font-weight: 500;
        font-size: 2em;
      }

      .pc-price-label {
        margin-top: auto;
        margin-left: 4px;
        margin-bottom: 4px;
        font-size: 0.75em;
        font-weight: 500;
        color: $N50;
      }
    }

    .pc-cc-container {
      font-size: 0.625em;
      color: $N60;
    }

    .pc-body-header {
      font-size: 0.875em;
      font-weight: 500;
      color: $N80;
      margin-bottom: 12px;
    }

    .pc-body-list-container {
      display: flex;
      flex-direction: column;
      margin-bottom: 16px;

      .pc-body-list-item {
        display: flex;
        align-items: flex-start;

        &:not(:last-child) {
          margin-bottom: 6px;
        }

        .bullet {
          margin-right: 8px;
          margin-top: 3px;
          min-width: 15px;
        }

        .pc-body-list-text {
          font-size: 0.6875em;
          color: $N70;
        }
      }
    }

    .pc-body-title {
      font-size: 0.75em;
      font-weight: 500;
      color: $N80;
      margin-bottom: 4px;
    }

    .pc-content-container {
      margin-bottom: 12px;
    }

    .pc-body-bubble-container {
      padding: 6px 4px 6px 8px;
      border: 1px solid #dfe7ff;
      border-radius: 20px;
      font-size: 0.6875em;
      color: $N80;
      display: flex;
      align-items: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      &:nth-child(3) {
        margin-top: 6px;
      }

      .pc-loyalty-name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      &--bonus {
        overflow: visible;
        text-overflow: unset;
        white-space: normal;
        padding: 5px 10px 5px 6px;
        gap: 8px;
        align-items: center;

        .pc-loyalty-name {
          overflow: visible;
          text-overflow: unset;
          white-space: normal;
        }

        .pc-bubble-icon {
          flex-shrink: 0;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 12px;
            height: 12px;
            display: block;
          }

          &--cc {
            background-color: #e8f5e9;
          }

          &--filter {
            background-color: #e3f2fd;
          }
        }

        .pc-bubble-bonus-text {
          display: flex;
          flex-wrap: wrap;
          align-items: baseline;
          gap: 0 6px;
          min-width: 0;
          line-height: 1.3;
        }

        .pc-bubble-bonus-accrual {
          color: $N60;
          font-size: 1em;
        }
      }
    }
  }

  .pc-footer-container {
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e1e9f0;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;

    .pc-plan-button {
      font-size: 12px;
      line-height: 1;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .pc-pref-badge-container {
    position: absolute;
    display: flex;
    height: 20px;
    padding: 0px 6px;
    margin-left: auto;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 4px;
    opacity: 0.8;
    background-color: $LIGHT_GREEN;
    right: -10px;
    top: -15px;
  }

  .pc-pref-badge-text {
    color: $BLACK;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.048px;
  }
}
</style>
